import { Button } from '@strata/react-buttons';
import { useNavigate } from 'react-router';

export interface ListPageHeaderButton {
    label: string;
    intent?: (typeof Button.Intent)[keyof typeof Button.Intent];
    path?: string;
    onClick?: () => void;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
}

interface ListPageHeaderProps {
    pageTitle: string;
    buttons?: ListPageHeaderButton[];
    rightContent?: React.ReactNode;
}

export const ListPageHeader = ({
    pageTitle,
    buttons = undefined,
    rightContent = undefined,
}: ListPageHeaderProps) => {
    const navigate = useNavigate();
    return (
        <div className="sds_list-page__header">
            <div className="sds_list-page__header__title">{pageTitle}</div>
            {(buttons?.length ?? 0) > 0 || rightContent ? (
                <div className="sds_list-page__header__right-container">
                    {rightContent}
                    {buttons?.map((button) => (
                        <Button
                            key={button.label}
                            intent={button.intent ?? Button.Intent.PRIMARY}
                            label={button.label}
                            disabled={button.disabled}
                            type={button.type ?? 'button'}
                            onClick={() => {
                                if (button.onClick) {
                                    button.onClick();
                                } else if (button.path) {
                                    navigate(button.path);
                                }
                            }}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
};
